<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row">
          <div class="form-unit">
            <div class="main-label">
              Does the plan allow the following types of employee contributions?
              What Is a maximum percent of compensation that can be contributed.
            </div>
          </div>
          <div class="form-unit"></div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row">
          <div class="form-unit">
            <div class="light-label">Pre-Tax</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.employee_contrib_pretax_yesno"
            >
              <roe-radio-input
                v-model="formData.employee_contrib_pretax_yesno"
              ></roe-radio-input>
            </roe-error-message>

            <roe-error-message
              v-if="showPreTax"
              :field="
                $v.formData.employee_contrib_pretax_max_contribution_percent
              "
            >
              <roe-percent-input
                v-model="
                  formData.employee_contrib_pretax_max_contribution_percent
                "
              ></roe-percent-input>
              <label class="input-label-inside">max %</label>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row">
          <div class="form-unit">
            <div class="light-label">Roth</div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.employee_contrib_roth_yesno">
              <roe-radio-input
                v-model="formData.employee_contrib_roth_yesno"
              ></roe-radio-input>
            </roe-error-message>

            <roe-error-message
              v-if="showRoth"
              :field="$v.formData.employee_contrib_roth_max_contribution"
            >
              <roe-percent-input
                v-model="formData.employee_contrib_roth_max_contribution"
              ></roe-percent-input>
              <label class="input-label-inside">max %</label>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row">
          <div class="form-unit">
            <div class="light-label">After-Tax</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.employee_contrib_aftertax_yesno"
            >
              <roe-radio-input
                v-model="formData.employee_contrib_aftertax_yesno"
              ></roe-radio-input>
            </roe-error-message>

            <roe-error-message
              v-if="showAfterTax"
              :field="$v.formData.employee_contrib_aftertax_max_contribution"
            >
              <roe-percent-input
                v-model="formData.employee_contrib_aftertax_max_contribution"
              ></roe-percent-input>
              <label class="input-label-inside">max %</label>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row">
          <div class="form-unit">
            <div class="light-label">Combined</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.employee_contrib_is_combined_max_yesno"
            >
              <roe-radio-input
                v-model="formData.employee_contrib_is_combined_max_yesno"
              ></roe-radio-input>
            </roe-error-message>

            <roe-error-message
              v-if="showCombined"
              :field="$v.formData.employee_combined_max_contribution"
            >
              <roe-percent-input
                v-model="formData.employee_combined_max_contribution"
              ></roe-percent-input>
              <label class="input-label-inside">max %</label>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row">
          <div class="form-unit">
            <div class="light-label">Catch-Up</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.employee_contrib_catchup_yesno"
            >
              <roe-radio-input
                v-model="formData.employee_contrib_catchup_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row">
          <div class="form-unit">
            <div class="light-label">Rollover</div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.employee_contrib_rollover_yesno"
            >
              <roe-radio-input
                v-model="formData.employee_contrib_rollover_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row">
          <div class="form-unit">
            <div class="common-label">Does the plan use Auto-Enrollment?</div>
          </div>
          <div class="form-unit">
            <roe-auto-enrollment-select
              :design="$v.formData"
            ></roe-auto-enrollment-select>
          </div>
          <div class="form-unit"></div>
        </div>
        <template v-if="showAutoEnrollment(formData)">
          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Effective Date</div>
            </div>
            <div class="form-unit">
              <roe-auto-enrollment-effective-date-input
                class="input-wrap--small"
                :design="$v.formData"
              ></roe-auto-enrollment-effective-date-input>
            </div>
            <div class="form-unit"></div>
          </div>
          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Auto-Enrollment Initial Percentage</div>
            </div>
            <div class="form-unit">
              <roe-auto-enrollment-initial-percent-input
                class="input-wrap--small"
                :design="$v.formData"
              ></roe-auto-enrollment-initial-percent-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Auto-Enrollment Contribution Type</div>
            </div>
            <div class="form-unit">
              <roe-auto-enrollment-contribution-type-radio
                :design="$v.formData"
              ></roe-auto-enrollment-contribution-type-radio>
            </div>
            <div class="form-unit"></div>
          </div>
        </template>

        <div class="form-row-devider"></div>

        <div class="form-row">
          <div class="form-unit">
            <div class="common-label">Does the plan use Auto-Increase?</div>
          </div>
          <div class="form-unit">
            <roe-auto-increase-select
              :design="$v.formData"
            ></roe-auto-increase-select>
          </div>
          <div class="form-unit"></div>
        </div>

        <template v-if="showAutoIncrease(formData)">
          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Effective Date</div>
            </div>
            <div class="form-unit">
              <roe-auto-increase-effective-date-input
                class="input-wrap--small"
                :design="$v.formData"
              ></roe-auto-increase-effective-date-input>
            </div>
            <div class="form-unit"></div>
          </div>
          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Auto-Increase Contribution Type</div>
            </div>
            <div class="form-unit">
              <roe-auto-increase-type-radio :design="$v.formData">
              </roe-auto-increase-type-radio>
            </div>
            <div class="form-unit"></div>
          </div>
          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Annual</div>
            </div>
            <div class="form-unit">
              <roe-auto-increase-annual-percent-input
                class="input-wrap--small"
                :design="$v.formData"
              >
              </roe-auto-increase-annual-percent-input>
            </div>
            <div class="form-unit"></div>
          </div>

          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Max</div>
            </div>
            <div class="form-unit">
              <roe-auto-increase-max-percent-input
                class="input-wrap--small"
                :design="$v.formData"
              ></roe-auto-increase-max-percent-input>
            </div>
            <div class="form-unit"></div>
          </div>
          <div class="form-row">
            <div class="form-unit">
              <div class="light-label">Auto Increase Date Type</div>
            </div>
            <div class="form-unit">
              <roe-auto-increase-date-type-select
                :design="$v.formData"
              ></roe-auto-increase-date-type-select>
            </div>
            <div class="form-unit"></div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";

import {
  required,
  minValue,
  maxValue,
  requiredIf
} from "vuelidate/lib/validators";
import {
  AutoEnrollmentMixin,
  AutoIncreaseMixin,
  InvalidFormWatcherMixin,
  ResetDesignAttributesMixin
} from "@/components/_shared/inputs/design/_mixins";
import {
  RoeAutoEnrollmentSelect,
  RoeAutoEnrollmentEffectiveDateInput,
  RoeAutoEnrollmentInitialPercentInput,
  RoeAutoEnrollmentContributionTypeRadio,
} from "@/components/_shared/inputs/design/auto-enrollment";
import {
  RoeAutoIncreaseSelect,
  RoeAutoIncreaseEffectiveDateInput,
  RoeAutoIncreaseTypeRadio,
  RoeAutoIncreaseAnnualPercentInput,
  RoeAutoIncreaseMaxPercentInput,
  RoeAutoIncreaseDateTypeSelect,
} from "@/components/_shared/inputs/design/auto-increase";

export default {
  name: "RoeEmployeeContributionsForm",
  props: ["formData"],
  components: {
    RoeAutoEnrollmentSelect,
    RoeAutoEnrollmentEffectiveDateInput,
    RoeAutoEnrollmentInitialPercentInput,
    RoeAutoEnrollmentContributionTypeRadio,
    RoeAutoIncreaseSelect,
    RoeAutoIncreaseEffectiveDateInput,
    RoeAutoIncreaseTypeRadio,
    RoeAutoIncreaseAnnualPercentInput,
    RoeAutoIncreaseMaxPercentInput,
    RoeAutoIncreaseDateTypeSelect,
    RoePercentInput,
    RoeRadioInput,
    RoeErrorMessage
  },
  mixins: [
    InvalidFormWatcherMixin,
    AutoEnrollmentMixin,
    AutoIncreaseMixin,
    ResetDesignAttributesMixin
  ],
  watch: {
    "formData.employee_contrib_pretax_yesno": function() {
      this.resetAttributes(this.$v.formData, "employee_contrib_pretax_yesno");
    },
    "formData.employee_contrib_roth_yesno": function() {
      this.resetAttributes(this.$v.formData, "employee_contrib_roth_yesno");
    },
    "formData.employee_contrib_aftertax_yesno": function() {
      this.resetAttributes(this.$v.formData, "employee_contrib_aftertax_yesno");
    },
    "formData.employee_contrib_is_combined_max_yesno": function() {
      this.resetAttributes(
        this.$v.formData,
        "employee_contrib_is_combined_max_yesno"
      );
    }
  },
  validations() {
    return {
      formData: {
        ...this.modifiedAutoEnrollmentValidations,
        ...this.modifiedAutoIncreaseValidations,
        ...this.selfValidations
      }
    };
  },
  computed: {
    modifiedAutoEnrollmentValidations() {
      let validations = this.autoEnrollmentValidations(this.formData);
      delete validations.auto_enrollment_applies_prior_employees;
      return validations;
    },
    modifiedAutoIncreaseValidations() {
      let validations = this.autoIncreaseValidations(this.formData);
      delete validations.auto_increase_applies_prior_employees;
      return validations;
    },
    selfValidations() {
      return {
        employee_contrib_pretax_yesno: { required },
        employee_contrib_roth_yesno: { required },
        employee_contrib_aftertax_yesno: { required },
        employee_contrib_is_combined_max_yesno: { required },
        employee_contrib_catchup_yesno: { required },
        employee_contrib_rollover_yesno: { required },
        employee_contrib_pretax_max_contribution_percent: {
          required: requiredIf(() => this.showPreTax),
          minValue: minValue(0.1),
          maxValue: maxValue(1),
          percent: true
        },
        employee_contrib_roth_max_contribution: {
          required: requiredIf(() => this.showRoth),
          minValue: minValue(0.1),
          maxValue: maxValue(1),
          percent: true
        },
        employee_contrib_aftertax_max_contribution: {
          required: requiredIf(() => this.showAfterTax),
          minValue: minValue(0.1),
          maxValue: maxValue(1),
          percent: true
        },
        employee_combined_max_contribution: {
          required: requiredIf(() => this.showCombined),
          minValue: minValue(this.minCombined),
          maxValue: maxValue(1),
          percent: true
        }
      };
    },
    showPreTax() {
      return this.formData.employee_contrib_pretax_yesno === 1;
    },
    showRoth() {
      return this.formData.employee_contrib_roth_yesno === 1;
    },
    showAfterTax() {
      return this.formData.employee_contrib_aftertax_yesno === 1;
    },
    showCombined() {
      return this.formData.employee_contrib_is_combined_max_yesno === 1;
    },
    minCombined() {
      return Math.max(
        this.formData.employee_contrib_pretax_max_contribution_percent,
        this.formData.employee_contrib_roth_max_contribution,
        this.formData.employee_contrib_aftertax_max_contribution
      );
    }
  }
};
</script>
